import script from "./UserQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./UserQuery.vue?vue&type=script&setup=true&lang=js"

import "./UserQuery.vue?vue&type=style&index=0&id=3723195f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3723195f"]])

export default __exports__